import { Link } from "react-router-dom";

// material-ui
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// project import
//import { APP_DEFAULT_PATH } from "config";

// assets
import construction from "assets/images/maintenance/under-construction.svg";

// ==============================|| UNDER CONSTRUCTION - MAIN ||============================== //

export default function UnderConstruction() {
  return (
    <Grid
      container
      spacing={4}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "100vh", py: 2 }}
    >
      <Grid item xs={12}>
        <Box sx={{ width: { xs: 300, sm: 480 } }}>
          <img
            src={construction}
            alt="mantis"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={2} justifyContent="center" alignItems="center">
          <Typography align="center" variant="h1">
            Under Maintenance
          </Typography>
          <Typography
            color="text.secondary"
            align="center"
            sx={{ width: "85%" }}
          >
            Hey! Please check out this site later. We are doing some maintenance
            on it right now.
          </Typography>
          <Button component={Link} to={"/"} variant="contained">
            Back To Home
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
